module.exports = __webpack_public_path__ + "static/Recruit01-2fe90de5328e5cac7922623e9acae57e.png";